import { useStore } from '../../../../hooks/useStore';
import Popup from '../../../../components/common-components/pop-up/Popup';
import { AlertCircle } from 'lucide-react';
import CommonButton from '../../../../components/common-components/button/CommonButton';
import footerStyles from '../../../../components/form-components/common-components/FormPopupFooter.module.css';
import styles from './NewOvertimePopup.module.css';

const RejectionReasonPopup = () => {
  const { popupStore, overtimeStore } = useStore();

  const handleClose = () => {
    popupStore.setIsRejectionReasonOpen(false);
    overtimeStore.setSelectedOvertime(null);
  };

  const selectedOvertime = overtimeStore.selectedOvertime;

  if (!selectedOvertime || !selectedOvertime.rejectionReason) {
    return null;
  }

  return (
    <Popup
      isOpen={popupStore.isRejectionReasonOpen}
      onClose={handleClose}
      title="Red Sebebi"
      description="Red sebebini görüntüleyin"
      variant="warning"
      icon={<AlertCircle size={22} strokeWidth={2} />}
      footer={
        <div className={footerStyles.actions}>
          <CommonButton
            type="outline"
            className={footerStyles.cancelBtn}
            onClick={handleClose}
          >
            Kapat
          </CommonButton>
        </div>
      }
    >
      <div className={styles.inputContainer}>
        <span className={styles.totalHoursLabel}>Red Sebebi</span>
        <div className={styles.reasonBox}>{selectedOvertime.rejectionReason}</div>
      </div>
    </Popup>
  );
};

export default RejectionReasonPopup;
